import type { PrevoyanceLandingProduct } from "@/app/components/pageModels/prevoyanceLanding/prevoyanceProducts"
import type { ProvidentProduct } from "@/app/components/providentForm/providentConfig"

// Plan de marquage prévoyance Prévoir (RM-898). Ne pas renommer : les triggers GTM et le
// dashboard CRM (table event_tracking via GET /api/provident/crm/dashboard) dépendent de ces noms.
// Le produit est porté par le nom d'event : le back écrase event_data à chaque incrément quotidien.
export const ProvidentTrackingEvents = {
    formView: (product: ProvidentProduct) => `prevoyance_${product}_form_view`,
    formStart: (product: ProvidentProduct) => `prevoyance_${product}_form_start`,
    submit: (product: ProvidentProduct) => `prevoyance_${product}_submit`,
    funnelAccess: (product: PrevoyanceLandingProduct) => `prevoyance_${product}_funnel_access`,
} as const

export const PROVIDENT_LEAD_GOOGLE_EVENT = "prevoyance_lead"
export const PROVIDENT_LEAD_FB_EVENT = "Lead"
